var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPath1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4295 0L9.975 5.351L6.35381 1.69H0C3.02925 6.633 10.5 10 10.5 10C10.5 10 17.9721 6.633 21 1.69H14.7L13.4295 0Z",
    fill: "#6D7278"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1);
export default __webpack_public_path__ + "static/media/Path1.04125ac1201f7b5f5dab73ab11f10d22.svg";
export { ForwardRef as ReactComponent };